import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const PushNotifications = {
  getPushNotificationForLoggedInUser,
  updateReadStatus,
  markNotificationsAsReadForAll,
  deletePushNotification,
  getPushNotificationReloadTimeStamp,
};

async function getPushNotificationForLoggedInUser(UserId) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_PUSH_NOTIFICATION_BY_USER}?UserId=${UserId}`,
    authHeader()
  );
  return response;
}

async function updateReadStatus(params) {
  const response = await APIHelper.post(
    `${APIURLConstants.UPDATE_PUSH_NOTIFICATION}`,
    {},
    authHeader(),
    params
  );
  return response;
}

async function markNotificationsAsReadForAll(params) {
  const response = await APIHelper.post(
    `${APIURLConstants.UPDATE_PUSH_NOTIFICATION}`,
    {},
    authHeader(),
    params
  );
  return response;
}

async function deletePushNotification(params) {
  const response = await APIHelper.post(
    `${APIURLConstants.DELETE_PUSH_NOTIFICATION}`,
    {},
    authHeader(),
    params
  );
  return response;
}

async function getPushNotificationReloadTimeStamp() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_PUSH_NOTIFICATION_TIMESTAMP}`,
    authHeader()
  );
  return response;
}
